import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";
import { createYupSync } from "@lib/helpers/TableHelper";
import { walletAddressSchema as yupSchema } from "@lib/schemas/wallet";
import { WalletAddressStatus, WalletAddressType } from "@lib/types/Billing";
import { Form, FormInstance, Input, Select } from "antd";
import useIntl from "react-intl/lib/src/components/useIntl";

type Props = {
  form: FormInstance<any>;
  loading: boolean;
  walletAddressId?: string;
};

export default function WalletAddressNetworkInput(props: Props) {
  const { form, loading, walletAddressId } = props;
  const { messages } = useIntl();
  const walletId = Form.useWatch("walletId", form);
  const status = Form.useWatch("status", form);
  const network = Form.useWatch("network", form);

  if (status === WalletAddressStatus.InUse && walletAddressId) {
    return (
      <Form.Item
        name="network"
        rules={[createYupSync({ schema: yupSchema })]}
        label={messages["common.walletNetwork"] as string}
      >
        <Input
          variant="borderless"
          disabled={true}
          prefix={
            <img
              src={walletAddressTypeImage(network)}
              style={{ width: "15px", height: "15px" }}
            />
          }
        />
      </Form.Item>
    );
  }

  return (
    <Form.Item
      name="network"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.walletNetwork"] as string}
    >
      <Select
        placeholder={messages["common.makeYourChoice"] as string}
        disabled={loading || !walletId}
        showSearch
        optionFilterProp="text"
        options={Object.entries(WalletAddressType).map(([key, value]) => ({
          label: (
            <StyledFlex style={{ gap: 5 }}>
              <img
                src={walletAddressTypeImage(value)}
                style={{ maxHeight: "15px" }}
              />
              {key}
            </StyledFlex>
          ),
          text: key,
          value: value,
        }))}
      />
    </Form.Item>
  );
}
